var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.320312,
  y: 0.820312,
  width: 24,
  height: 24,
  rx: 8,
  fill: "#F1F9FF"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4683_20403)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.32031 8.19531C8.15455 8.19531 7.99558 8.26116 7.87837 8.37837C7.76116 8.49558 7.69531 8.65455 7.69531 8.82031V13.3203C7.69531 13.4861 7.76116 13.645 7.87837 13.7623C7.99558 13.8795 8.15455 13.9453 8.32031 13.9453H8.82031C9.02742 13.9453 9.19531 14.1132 9.19531 14.3203C9.19531 14.5274 9.02742 14.6953 8.82031 14.6953H8.32031C7.95564 14.6953 7.6059 14.5504 7.34804 14.2926C7.09018 14.0347 6.94531 13.685 6.94531 13.3203V8.82031C6.94531 8.45564 7.09018 8.1059 7.34804 7.84804C7.6059 7.59018 7.95564 7.44531 8.32031 7.44531H12.8203C13.185 7.44531 13.5347 7.59018 13.7926 7.84804C14.0504 8.1059 14.1953 8.45564 14.1953 8.82031V9.32031C14.1953 9.52742 14.0274 9.69531 13.8203 9.69531C13.6132 9.69531 13.4453 9.52742 13.4453 9.32031V8.82031C13.4453 8.65455 13.3795 8.49558 13.2623 8.37837C13.145 8.26116 12.9861 8.19531 12.8203 8.19531H8.32031ZM11.8203 11.6953C11.4751 11.6953 11.1953 11.9751 11.1953 12.3203V16.8203C11.1953 17.1655 11.4751 17.4453 11.8203 17.4453H16.3203C16.6655 17.4453 16.9453 17.1655 16.9453 16.8203V12.3203C16.9453 11.9751 16.6655 11.6953 16.3203 11.6953H11.8203ZM10.4453 12.3203C10.4453 11.5609 11.0609 10.9453 11.8203 10.9453H16.3203C17.0797 10.9453 17.6953 11.5609 17.6953 12.3203V16.8203C17.6953 17.5797 17.0797 18.1953 16.3203 18.1953H11.8203C11.0609 18.1953 10.4453 17.5797 10.4453 16.8203V12.3203Z",
  fill: "#00538F"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4683_20403"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(6.32031 6.82031)"
})));

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.99b9733b.svg";
export { ForwardRef as ReactComponent };